<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="isSaving && isSaveable ? 6 : 12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100; display: inline-block;">NEW AP ENTRY</h2>
        </el-row>
      </el-col>
      <el-col :span="12" v-if="isSaving && isSaveable">
        <TransactionProgressBar
          :totalRequests="totalRequests"
          :completedRequests="completedRequests"
          :error="(!!failedLines.length)"
        />
      </el-col>
      <DataEntryButtons
        :isSaveable="isSaveable"
        :isOpenable="isOpenable"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :transactionType="transactionType"
        :hasPermission="hasPermission"
        @goBack="goBack"
        @submit="submitForm"
        @otherActions="otherActions"
        @dropdownClick="handleDropdownClick"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
    <el-row justify="start" align="top" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" style="padding-right: 10px">
        <el-row justify="start" align="top" type="flex">
          <HeaderFields
            title="Vendor"
            :fields="fields.vendor"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :specialCellDisplayValue="vendorOpenPOs"
            :specialCellBtnLabel="fetchingPoData ? 'Loading...' : 'Import PO Lines'"
            :linesContainReliefLines="linesContainReliefLines"
            :isSaving="isSaving"
            @specialCellBtnClick="handleImportPoDialogVisible(true)"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="padding: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Invoice Data"
            :fields="fields.invoiceData"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
            :key="effectiveDateMandatory"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="padding-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            :lines="lines"
            :idPrefix="'e-'"
            :modalOpen="dialogVisible"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Payment Info"
            :fields="fields.paymentInfo"
            :form="form"
            :idPrefix="'d-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="ap"
        ref="distribution-lines"
        :fields="lineFields"
        :existingLines="lines"
        :vendorPoLines="vendorPoLines"
        :initLines="20"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :reset="resetLines"
        :fetchingPoLines="fetchingPoData"
        :readOnly="isSaving"
        :fieldsToClear="lineFieldsToClear"
        :hasEditPermission="hasEditPermission"
        @lineChanged="trackLineChanges"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @lineAmountChanged="lineAmountChanged"
        @hasBeenReset="linesHaveBeenReset"
        @updateLines="updateLines"
        @mounted="onMountedSetLines"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      v-model="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>Do you wish to save this transaction as a draft?</span>
      <template v-slot:footer><span class="dialog-footer">
        <el-button
          class="exit-modal-btn"
          :disabled="isSaving"
          @click="cancelExit">
          Cancel
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          :disabled="isSaving"
          @click="goBack(true)">
          No
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          :disabled="isSaving"
          :loading="isSaving"
          @click="confirmSaveBeforeExit">
          Yes
        </el-button>
      </span></template>
    </el-dialog>
    <RouteChangeDialog :visible="showExitWarningDialog" @isVisible="handleExitWarningDialogVisible" @confirm="goBack(true)" />
    <el-dialog
      title="Select PO Lines to Import"
      v-model="importPoDialogVisible"
      width="82%"
      id="el-dialog-pos-table"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <el-row type="flex" justify="end" align="middle" v-if="!fetchingPoData" style="z-index: 2010; bottom: 20px;">
        <el-button @click="handleImportPoDialogVisible(false)">
          Cancel
        </el-button>
        <el-button
          type="primary"
          :disabled="!selectedPoLines.length"
          @click="importPoLines">
          Done
        </el-button>
      </el-row>
      <div style="padding: 0 20px;">
        <el-row type="flex" align="middle" justify="center">
          <el-table
            v-loading="fetchingPoData"
            element-loading-text="Loading POs and related lines"
            id="import-po-table"
            :data="filterPoList(poList)"
            border
            default-expand-all
            :row-key="getRowKey"
            ref="importPoCarousel">
            <el-table-column type="expand" style="width: 82% !important">
              <template v-slot="props">
                <el-table 
                  width="82%"
                  :id="'po-lines-table_' + props.row.id"
                  :data="filterPoLines(props.row.lines)"
                  border
                  :row-key="getRowKey"
                  @selection-change="selectPoLines(props.row, $event)"
                  :ref="'importPoLinesTable_' + props.row.id"
                >
                  <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
                  <el-table-column prop="line_number" label="No" width="70" />
                  <el-table-column prop="account_code" label="Account" width="130" />
                  <el-table-column prop="account_name" label="Account Name" width="200" />
                  <el-table-column prop="meta_name" label="Description" />
                  <el-table-column prop="amount_decimal" label="Amount" width="100">
                    <template #default="scope">
                      {{ formatAmountLocale(scope.row.amount_decimal) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="remaining_decimal" label="Remaining" width="100">
                    <template #default="scope">
                      {{ formatAmountLocale(scope.row.remaining_decimal) }}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="No" />
            <el-table-column prop="description" label="Description" />
            <el-table-column prop="amount_decimal" label="Amount">
              <template #default="scope">
                {{ formatAmountLocale(scope.row.amount_decimal) }}
              </template>
            </el-table-column>
            <el-table-column prop="remaining" label="Remaining" width="100">
              <template #default="scope">
                {{ formatAmountLocale(scope.row.remaining) }}
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <el-row type="flex" justify="end" align="middle" v-if="!fetchingPoData" style="padding: 20px 0 0 0;">
        <el-button @click="handleImportPoDialogVisible(false)">
          Cancel
        </el-button>
        <el-button
          type="primary"
          :disabled="!selectedPoLines.length"
          @click="importPoLines">
          Done
        </el-button>
      </el-row>
    </el-dialog>
    <NewBatch :hasCreatePermission="userCanCreateBatch" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <ClosePoNotifModal
      v-model="closePoLineModalVisible"
      :poLines="underRelievedPoLines"
      :actualPoLines="vendorPoLines"
      :reliefStatus="reliefStatus"
      @closePoNotifModalVisible="handleClosePoNotifVisibility"
      @closePoLines="setSelectedPoLinesAsClosed"
    />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew1.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import ClosePoNotifModal from './ClosePoNotifModal.vue'
  import { isTransactionBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionCreateViewMixins, transactionCreateBeforeRouteEnter } from '@/Mixins/TransactionCreateViews'
  import { vendorMixins } from '@/Mixins/VendorMixins'
  import RouteChangeDialog from '@/components/RouteChangeDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import TransactionProgressBar from '@/components/TransactionProgressBar.vue'
  import { getSimpleDate } from '@/utils/helpers/FormatDate'
  import store from '@/store/store'
  import { formatAmount } from '@/utils/helpers/AmountFormatter'
  
  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      DataEntryButtons,
      ClosePoNotifModal,
      RouteChangeDialog,
      TransactionProgressBar,
      LinesLoading
    },
    mixins: [ transactionMixins, transactionCreateViewMixins, vendorMixins ],
    beforeRouteEnter: transactionCreateBeforeRouteEnter,
    data () {
      const batch = this.setFormBatch()
      return {
        modelId: null,
        transactionType: { name: 'ap', path: '/aps/', prettyName: 'Accounts Payable' },
        form: {
          batch: { label: batch ? batch.name : '', value: batch ? batch.id : '' },
          vendor: { label: '', value: '' },
          period: '',
          number: '',
          description: '',
          date: getSimpleDate(new Date(), 'yyyy-mm-dd'),
          amount_decimal: '',
          discount_decimal: '0.00',
          date_due: '',
          payment_combine_checks: true,
          payment_type: 'CHECK',
          payment_confirmation_number: '',
          bank_transaction_number: '',
          payment_check_split: '',
          payment_check_pickup: false,
          state: '',
          effective_date: '',
          payment_date: '',
          lines: []
        },
        lines: [],
        reliefStatus: '',
        effectiveDateMandatory: false,
        importPoDialogVisible: false,
        selectedPoLines: [],
        selPoLines: [],
        fetchingPoData: false,
        prePoLineValidation: false,
        closePoLineModalVisible: false,
        underRelievedPoLines: [],
        onSubmitOpts: {},
        notificationBox: undefined,
        autoEnterLineLimit: 3 // when adding default values like account, tax code
      }
    },
    methods: {
      formatAmountLocale (value) {
        return formatAmount(value)
      },
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      /**
       * Checks for PO lines that are underrelieved by checking whether the actual AP line's amount_decimal is
       * less than the original PO line's amount_decimal
       * @returns {boolean}
       */
      checkForUnderRelievedPoLines () {
        this.prePoLineValidation = false
        this.reliefStatus = ''
        this.underRelievedPoLines = this.lines.filter(line => {
          if (!(line && line.form && line.form.relieves && line.form.relieves.value > 0)) return false
          const poLineId = line.form.relieves.value
          const poLine = this.getPoLineById(poLineId)
          return Boolean(Object.keys(poLine).length)
        })
        this.reliefStatus = 'Under'
        return !!(this.underRelievedPoLines && this.underRelievedPoLines.length)
      },
      /**
       * Adds the 'relieves_force_close' property to under-relieved PO lines that the user has
       * selected to be closed out
       * @param selection
       */
      setSelectedPoLinesAsClosed (selection) {
        this.closePoLineModalVisible = false
        if (selection && selection.length > 0) {
          for (let line in selection) {
            (this.lines.find((l) => parseInt(l.line_number || l.form.line_number) === parseInt(line)).form || {}).relieves_force_close = selection[line]
          }
        }
        if (!this.prePoLineValidation) {
          const { addAnother, afterSubmit, close } = this.onSubmitOpts
          this.showTrxActionLoader('Saving...')
          this.submitForm(addAnother, afterSubmit, close)
          this.onSubmitOpts = Object.assign({})
        } else {
          this.prePoLineValidation = false
        }
        this.reliefStatus = ''
      },
      /**
       * Shows or hides the modal responsible for checking whether the user wants to close an
       * under-relieved PO line that has been imported.
       * @param visible
       */
      handleClosePoNotifVisibility (visible) {
        if (!visible) this.onSubmitOpts = Object.assign({})
        this.prePoLineValidation = false
        this.closePoLineModalVisible = visible
        this.reliefStatus = ''
      },
      /**
       * Updates header form
       */
      async updateForm (form, changedField = null, action = null) {
        if (changedField === 'payment_confirmation_number' && form.payment_confirmation_number === null) {
          return
        }
        if (changedField === 'vendor') {
          this.handleVendorChange(form)
        } else if (changedField === 'batch') {
          this.handleBatchChange(form)
        }
        this.form = form
        if (changedField === 'payment_date' || changedField === 'date') this.paymentDateValidation(form.date, form.payment_date, action)
        isTransactionBalanced(this)
        this.trackHeaderChanges()
        this.isSaveable = this.checkIfCanBeSaved()
        this.isOpenable = this.transactionIsBalanced && this.checkIfCanBeSaved()
        this.updateCheckSplitField()
        this.trackVendorNumberChange()

        // Update first dist line if necessary
        if (changedField === 'amount_decimal') {
          this.setFirstLineAmount(form[changedField])
        }
        if (changedField === 'payment_type') {
          this.updateCombine()
        }
      },

      async handleVendorChange (form) {
        if (this.linesContainReliefLines) {
          this.clearLineFields(['relieves'])
          this.currentVendorSelection = ''
          this.selectedPoLines = []
          this.fetchingPoData = false
        }
        if (form.vendor.value) {
          let vendorData = this.getVendorById(form.vendor.value)
          if (!vendorData.id) {
            await this.$store.dispatch('fetchVendorById', form.vendor.value)
            vendorData = this.getVendorById(form.vendor.value)
            if (vendorData && vendorData.address_selected && vendorData.address_selected.id && vendorData.address_selected.city) {
              await this.$store.dispatch('fetchCitiesWithQuery', { id__in: [vendorData.address_selected.city], page_size: 1 })
            }
            this.currentVendorSelection = form.vendor.value
          } else {
            if (vendorData && vendorData.address_selected && vendorData.address_selected.id && vendorData.address_selected.city && typeof vendorData.address_selected.city === 'number') {
              await this.$store.dispatch('fetchCitiesWithQuery', { id__in: [vendorData.address_selected.city], page_size: 1 })
            }
            this.currentVendorSelection = form.vendor.value
          }
        }
      },

      handleBatchChange (form) {
        this.setBatchAttributeLineValues(this.batchAttributes)
        this.setBankAttributeLineValues(this.bankAttributes)
      },

      /**
       * When line amount changed, check for over relieved po line
       * @param line
       */
      lineAmountChanged (line) {
        this.underRelievedPoLines = []
        let activeLine = this.lines.find((v) => { return v.line_number === line.line_number })
        if (!activeLine || !activeLine.form) return
        const lineAmount = activeLine.form.amount_decimal
        if (activeLine.form.relieves && activeLine.form.relieves.value) {
          let poLine = this.getPoLineById(activeLine.form.relieves.value)
          if (Number(poLine.amount_decimal) < Number(lineAmount)) {
            this.underRelievedPoLines.push(activeLine)
            this.prePoLineValidation = true
            this.closePoLineModalVisible = true
            this.reliefStatus = 'Over'
          }
        }
      },

      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        if (lines) {
          this.lines = lines
          isTransactionBalanced(this)
          this.isSaveable = this.checkIfCanBeSaved()
          this.isOpenable = this.transactionIsBalanced && this.checkIfCanBeSaved()
        }
      },
      /**
       * Updates the payment_check_split header field according to whether payment_combine_checks is
       * true or false. If true, then the check cannot be split and thus payment_check_split is
       * set to 1.
       */
      updateCheckSplitField () {
        const index = this.fields.paymentInfo.inputFields.findIndex(v => v.name === 'payment_check_split')
        if (this.form.payment_combine_checks) {
          this.fields.paymentInfo.inputFields[index].disabled = true
          this.form.payment_check_split = ''
        } else {
          this.fields.paymentInfo.inputFields[index].disabled = false
          this.form.payment_check_split = this.form.payment_check_split ? `${this.form.payment_check_split}` : ''
        }
      },
      /**
       * Resets the component's internal state
       */
      resetForm () {
        const batch = this.setFormBatch(this.form.batch.value)
        const form = {
          batch: { label: batch ? batch.name : '', value: batch ? batch.id : '' },
          vendor: { label: '', value: '' },
          period: { label: '', value: '' },
          number: '',
          description: '',
          date: getSimpleDate(new Date(), 'yyyy-mm-dd'),
          amount_decimal: '',
          discount_decimal: '0.00',
          date_due: '',
          payment_combine_checks: true,
          payment_type: 'CHECK',
          payment_confirmation_number: '',
          payment_check_split: '',
          payment_check_pickup: false,
          state: '',
          effective_date: this.effectiveDateMandatory ? getSimpleDate(new Date(), 'yyyy-mm-dd') : '',
          payment_date: ''
        }
        this.form = form
        this.currentVendorSelection = ''
        this.importPoDialogVisible = false // TODO: this can go
        this.selectedPoLines = []
      },
      /**
       * Tracks changes to the vendor
       */
      trackVendorNumberChange () {
        const vendor = this.form.vendor.value
        const number = this.form.number
        this.vendorNumberVerifier = `${vendor}${number}`
      },
      /**
       * Governs visibility of the "Import PO" modal
       */
      handleImportPoDialogVisible (visible) {
        if (visible) this.getPoList()
        this.importPoDialogVisible = visible
      },
      getRowKey (row) {
        return row.id
      },
      /**
       * Handles selecting PO lines in the importPoDialog
       * @param lines   The selected PO lines
       */
      selectPoLines (transaction, lines) {
        this.selectedPoLines = this.selectedPoLines.filter((v) => v.transaction_id !== transaction.id)
        if (lines.length) {
          this.selectedPoLines = [...this.selectedPoLines, ...lines]
        }
      },
      /**
       * Checks if the user has already entered lines and if so, gets the indexes of the next available lines
       */
      importPoLines () {
        const selectedPoLines = [...new Set(this.selectedPoLines)]
        // get po line accounts
        const selectedPoLinesAccounts = selectedPoLines.map(v => v.account)
        this.$store.dispatch('fetchAccountsWithQuery', { id__in: [...new Set(selectedPoLinesAccounts)], page_size: selectedPoLinesAccounts.length })

        const getCode = (id, getter) => {
          let model
          if (typeof this.$store.getters[getter] === 'function') {
            model = this.$store.getters[getter](id)
          }
          return model && model.code ? model.code : ''
        }
        const setAmountDecimal = (line) => {
          if (line && line.hasOwnProperty('amount_decimal') && parseFloat(line.amount_decimal) < 0 && line.hasOwnProperty('remaining_decimal') && parseFloat(line.remaining_decimal) === 0) {
            return line.amount_decimal
          } else if (line && line.hasOwnProperty('remaining_decimal')) {
            return line.remaining_decimal
          } else if (line && !line.hasOwnProperty('remaining_decimal') && line.hasOwnProperty('amount_decimal')) {
            return line.amount_decimal
          }
          return ''
        }
        selectedPoLines.forEach(l => {
          let poLineAccount = ''
          if (l.account && l.account_code) {
            poLineAccount = { label: l.account_code, value: l.account }
          } else {
            poLineAccount = { label: getCode(l.account, 'getAccountById'), value: l.account }
          }
          let form = {
            relieves: l.hasOwnProperty('meta_name') ? { label: l.meta_name, value: l.id } : '',
            description: l.description || '',
            other_name: l.other_name || '',
            amount_decimal: setAmountDecimal(l),
            asset: !!l.asset,
            account: poLineAccount,
            series: { label: getCode(l.series, 'getSeriesById'), value: l.series || '' },
            location: { label: getCode(l.location, 'getLocationById'), value: l.location || '' },
            set: { label: getCode(l.set, 'getSetById'), value: l.set || '' },
            tax_code: { label: getCode(l.tax_code, 'getTaxcodeById'), value: l.tax_code || '' },
            free_field_1: { label: getCode(l.free_field_1, 'getFreefieldById'), value: l.free_field_1 || '' },
            free_field_2: { label: getCode(l.free_field_2, 'getFreefieldById'), value: l.free_field_2 || '' },
            free_field_3: { label: getCode(l.free_field_3, 'getFreefieldById'), value: l.free_field_3 || '' },
            free_field_4: { label: getCode(l.free_field_4, 'getFreefieldById'), value: l.free_field_4 || '' },
            third_party_vendor: { label: getCode(l.third_party_vendor, 'getVendorById'), value: l.third_party_vendor || '' },
            is_offset: false
          }
          // Why oh why are we using this instead of fillFieldsWithPoLineData
          // hacking the necessary functionality instead
          this.$store.dispatch('fetchPoLinesWithQuery', {id: l.id})
          if (this.$refs['distribution-lines'].addExistingLine &&
            typeof this.$refs['distribution-lines'].addExistingLine === 'function') {
            this.$refs['distribution-lines'].addExistingLine({ line_number: null, form }, true)
          }
        })
        this.importPoDialogVisible = false
        this.selectedPoLines = []
      },
      /** On load set Batch and bank attributes */
      onMountedSetLines () {
        this.setBatchAttributeLineValues(this.batchAttributes)
        this.setBankAttributeLineValues(this.bankAttributes)
      }
    },
    computed: {
      ...mapGetters({
        getPoById: 'getPoById',
        getPoLines: 'getPoLines',
        getPoLineById: 'getPoLineById',
        getPoLinesFetchStatus: 'getPoLinesFetchStatus',
        getAccountById: 'getAccountById',
        getSeriesById: 'getSeriesById',
        getLocationById: 'getLocationById',
        getSetById: 'getSetById',
        getTaxcodeById: 'getTaxcodeById',
        getFreefieldById: 'getFreefieldById',
        getPoMetadata: 'getPoMetadata',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
      }),
      states () {
        return this.$store.getters.getAllStates.map(v => ({ label: v.name, value: v.id }))
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_accountspayable', 'entry.add_accountspayable'])
      },
      hasExportAchPermission () {
        return this.hasCreatePermission && this.checkIfUserHasRequiredPermissions(['entry.ach_payment'])
      },
      hasEditPermission () {
        if (!this.hasCreatePermission) return false
        else return true
      },
      userCanCreateBatch () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_batch', 'entry.add_batch'])
      },
      hasPermission () {
        return {
          create: this.hasCreatePermission,
          edit: this.hasEditPermission,
          delete: true,
          post: true
        }
      },
      fields () {
        let fields = {
          vendor: {
            inputFields: [
              {
                name: 'vendor',
                label: 'Vendor',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'vendors/vendor_specific_columns', params: { active: 'True' } },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a vendor',
                addBtn: this.userCanCreateVendor
              }
            ],
            displayFields: [
              {
                name: 'vendor',
                label: 'Address',
                value: this.vendorAddressLine || ''
              },
              {
                name: 'vendor',
                label: 'Open POs',
                value: this.filterPoList(this.poList).length || '',
                specialCell: true
              },
              {
                name: 'vendor',
                label: 'Type',
                value: this.form.vendor.value ? this.getVendorById(this.form.vendor.value).entity_type : ''
              }
            ]
          },
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches', params: { active: true } },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                addBtn: this.userCanCreateBatch
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          invoiceData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'number',
                label: 'Invoice number',
                dataType: 'string',
                fieldType: 'input',
                required: true
              },
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                isMoney: true
              },
              {
                name: 'discount_decimal',
                label: 'Discount',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                isMoney: true
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                msg: 'Please specify a date'
              },
              {
                name: 'date_due',
                label: 'Due Date',
                dataType: 'string',
                fieldType: 'date',
                msg: 'Please specify a due date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                fieldType: 'date'
              },
              {
                label: 'State',
                name: 'state',
                placeholder: 'Select a state...',
                dataType: 'number',
                fieldType: 'select',
                remote: false,
                filterable: true,
                options: this.states
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              }
            ]
          },
          paymentInfo: {
            inputFields: [
              {
                name: 'payment_combine_checks',
                label: 'Combine checks',
                dataType: 'boolean',
                fieldType: 'checkbox'
              },
              {
                name: 'payment_type',
                label: 'Payment type',
                dataType: 'string',
                fieldType: 'select',
                required: true,
                options: this.hasExportAchPermission ? [
                  { label: 'Check', value: 'CHECK' },
                  { label: 'Wire Transfer', value: 'WIRE' },
                  { label: 'EFT', value: 'EFT' },
                  { label: 'Manual Check', value: 'CHECK_MANUAL' },
                  { label: 'N/A', value: 'NA' }
                ] : [
                  { label: 'Check', value: 'CHECK' },
                  { label: 'Wire Transfer', value: 'WIRE' },
                  { label: 'Manual Check', value: 'CHECK_MANUAL' },
                  { label: 'N/A', value: 'NA' }
                ]
              },
              {
                name: 'bank_transaction_number',
                label: 'Bank Transaction #',
                dataType: 'string',
                fieldType: 'input',
                required: this.form.payment_type === 'CHECK_MANUAL',
                tooltip: "Bank's reference number for this transaction. Required for Manual Check; optionally pre-filled for EFT/Wire based on settings."
              },
              {
                name: 'payment_date',
                label: 'Payment Date',
                dataType: 'string',
                fieldType: 'date'
              },
              {
                name: 'payment_check_split',
                label: 'Check amount split',
                dataType: 'string',
                fieldType: 'input',
                disabled: true
              },
              {
                name: 'payment_check_pickup',
                label: 'Pickup check',
                dataType: 'boolean',
                fieldType: 'checkbox'
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Transaction #',
                value: ''
              },
              {
                label: 'Date created',
                value: this.formatDateToLocale(new Date())
              },
              {
                label: 'Date posted',
                value: ''
              },
              {
                label: 'Status',
                value: 'NEW'
              },
              {
                name: 'runningTotal',
                label: 'Total Distributed',
                prefix: this.currency ? this.currency.symbol : ''
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.invoiceData.inputFields[8].options.push({
            label: 'Current',
            value: this.currentPeriod.id,
            selected: true
          })
        }
        return fields
      }
    },
    watch: {
      currentVendorSelection () {
        if (this.currentVendorSelection) {
          this.getPoList()
          this.setDefaultPaymentType()
          this.setDefaultTaxcodeLineValues()
          this.setDefaultAccountLineValues()
          // this.setDefaultFreeFieldLineValues()
          this.setDefaultState()
        } else {
          this.poList = []
        }
      },
      vendorNumberVerifier () {
        this.trxAlreadyExists = false
        if (this.trxAlreadyExistsMsg) this.trxAlreadyExistsMsg.close()
        clearTimeout(this.vendorNumberCheckTimeout)
        this.vendorNumberCheckTimeout = setTimeout(() => this.checkIfTrxExists(), 1000)
      },
      vendorPoLines () {
        this.createRelievesFieldOptions()
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await store.dispatch('clearPoState', true)
        // CP6: Vue 3 removed vm.$destroy(). vue-router unmounts this route component when the guard calls
        // next(), so the explicit teardown is unnecessary (and would throw under @vue/compat MODE 3).
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>

<!-- el-dialog teleports to <body>, so its internals never carry this component's scoped data-v
     attribute. These rules must be global (keyed by the dialog's unique id) or they never apply. -->
<style>
  #el-dialog-pos-table {
    top: -10%;
  }
  /* Make the PO -> lines grouping read clearly: indent + tint the expanded child-lines region so the
     nested lines table sits inside the outer PO table. */
  #el-dialog-pos-table .el-table__expanded-cell {
    background: #f5f7fa;
    padding: 8px 8px 8px 50px;
  }
</style>
